<template lang="pug">
v-row
  v-col(cols="12" lg="8")
    v-slide-y-reverse-transition(leave-absolute)
      v-skeleton-loader(
        v-if="loading"
        type="list-item-two-line@5"
      )
    v-slide-y-reverse-transition(
      leave-absolute
    )
      v-card.sdo-card(v-if="!loading" )
        v-card-text
          .title.pb-2 Настройка уведомлений
          v-list(height="700"  rounded).overflow-auto.scroll
            v-list-group(
              v-for="(course, courseIdx) in courses"
              :key="course.id"
            )
              template(#activator)
                v-list-item-action
                  v-checkbox(
                    v-model="selectedItems.courses"
                    :value="course.id"
                    :indeterminate="getSelectedItems[courseIdx].indeterminate"
                    @change="onSelectCourse($event, course)"
                    @click.stop
                  )
                v-list-item-title {{  course.title }}
              v-list-item-group(
                v-model="selectedItems.units"
                multiple
              )
                v-list-item(
                  v-for="(unit, idx) in course.course_units"
                  :key="idx"
                  :value="`${unit.id}:${course.id}`"
                  @click="onSelectUnit(unit, courseIdx, course.id)"
                )
                  template(#default="{ toggle, active }")
                    v-list-item-action.pl-8
                      v-checkbox(
                        :input-value="active"
                        @change="onSelectUnit(unit, courseIdx, course.id)"
                        @click.stop="setUnit(`${unit.id}:${course.id}`)"
                      )
                    v-list-item-title {{ unit.title }}
  v-col(:style="`order: ${!$vuetify.breakpoint.lgAndUp ? -1 : 2}`")
    v-card(
      color="secondary"
      dark
    ).sdo-card
      v-card-title
        v-btn(small outlined @click="selectAll")  Выбрать все
        v-spacer
        v-btn(
          v-if="selectedItems.units.length"
          rounded
          depressed
          light
          small
          :loading="saveLoading"
          color="white"
          @click="reset"
        ).ml-2.px-2
          span() Выбрано тем: {{ selectedItems.units.length }}
          v-icon(small) mdi-close
      v-card-text.pb-0
        v-alert(
          type="info" color="transparent" prominent
        ) Уведомления по консультациям будут приходить по выбранным темам
      v-card-actions
        v-btn(block color="success" large @click="setSubscribes") Cохранить
</template>
<script>
import _ from 'lodash';

export default {
  data() {
    return {
      loading: true,
      selectedItems: {
        courses: [],
        units: [],
      },
      savedNotifications: {
        courses: [],
        units: [],
      },
      courses: [],
      saveLoading: false,
    };
  },

  computed: {
    getSelectedItems() {
      const courses = this.courses.map((i) => {
        const units = i?.course_units?.filter((u) => u.isSelected);
        return {
          id: i.id,
          selectedAllUnits: units?.length >= i?.course_units?.length,
          indeterminate: i?.course_units?.length > units?.length && units?.length > 0,
          units: units?.map((u) => u.id),
        };
      });
      return courses;
    },
  },
  async created() {
    await this.getSubscribes();
    await this.fetchCourses();
  },
  methods: {
    async getSubscribes() {
      const { data } = await this.$api.notifications.getSubscribes();
      const result = data.data.reduce((acc, cur) => {
        if (cur.type === 'course') acc.courses.push(cur.target_id);
        else acc.units.push(`${cur.target_id}:${cur.course_id}`);
        return acc;
      }, { courses: [], units: [] });
      this.savedNotifications = data.data;
      this.selectedItems = result;
    },
    fetchCourses() {
      return this.$rHandler(
        this.$api.courses.getCourseList({
          'search[teacher_or_curator]': this.$user.data.id,
          'search[has_prior_records]': true,
          'per-page': -1,
          expand: 'course_units',
        }),
        (resp) => {
          this.courses = resp.data.data.map((i) => {
            const courseSelected = this.selectedItems.courses.includes(i.id);
            const result = {
              ...i,
              course_units: i.course_units ? i.course_units.map((item) => ({
                ...item,
                isSelected: this.selectedItems.units.includes(`${item.id}:${i.id}`),
              })) : [],
            };
            if (courseSelected) this.onSelectCourse(this.selectedItems.courses, result);
            return result;
          });
          this.loading = false;
        },
      );
    },

    async setSubscribes() {
      this.saveLoading = true;
      const { courses, units } = this.selectedItems;
      const selectedUnits = units.filter((unit) => !courses.includes(+unit.split(':')[1]));
      const serverUnits = selectedUnits.map((i) => {
        const [unitId, courseId] = i.split(':');
        return { type: 'course-unit', target_id: +unitId, course_id: +courseId };
      });
      const serverCourses = courses.map((i) => ({ type: 'course', target_id: i }));
      const unSelected = this.savedNotifications.filter((i) => {
        const course = i.type === 'course' && !courses.some((b) => b === i.target_id);
        const unit = i.type === 'course-unit' && !units.some((b) => {
          const [unitId, courseId] = b.split(':');
          return i.target_id === +unitId && +courseId === i.course_id;
        });
        return course || unit;
      });

      await this.$api.notifications.setSubscribes([...serverCourses, ...serverUnits]);
      if (unSelected.length) {
        await this.$api.notifications.unSetSubscribe({ ids: unSelected.map((i) => i.id) });
      }
      this.saveLoading = false;
      this.$toasted.success('Успешно');
    },

    onSelectUnit(unit, courseIdx, courseId) {
      unit.isSelected = !unit.isSelected;
      if (this.getSelectedItems[courseIdx].selectedAllUnits
      && !this.selectedItems.courses.includes(courseId)) {
        this.selectedItems.courses.push(courseId);
      } else {
        const idx = this.selectedItems.courses.findIndex((id) => courseId === id);
        if (idx >= 0) {
          this.selectedItems.courses.splice(idx, 1);
        }
      }
    },
    onSelectCourse(value, course) {
      const { id: courseId, course_units: courseUnits } = course;
      const isSelected = value.includes(courseId);
      if (isSelected) {
        this.selectedItems.units = _.union(
          this.selectedItems.units,
          courseUnits.map((i) => `${i.id}:${courseId}`) || [],
        );
        course.course_units = courseUnits?.map((item) => ({
          ...item,
          isSelected: true,
        })) || [];
      } else {
        this.selectedItems.units = _.without(
          this.selectedItems.units,
          ...courseUnits.map((i) => (`${i.id}:${courseId}`)),
        );
        course.course_units = courseUnits?.map((item) => ({
          ...item,
          isSelected: false,
        })) || [];
      }
    },

    setUnit(id) {
      const idx = this.selectedItems.units.findIndex((i) => i === id);
      if (idx >= 0) this.selectedItems.units.splice(idx, 1);
      else this.selectedItems.units.push(id);
    },
    reset() {
      this.courses = this.courses.map((i) => ({
        ...i,
        isSelected: false,
        units: i.course_units?.map((item) => ({ ...item, isSelected: false })) || [],
      }));
      this.selectedItems = {
        courses: [],
        units: [],
      };
    },
    selectAll() {
      this.courses = this.courses.map((i) => ({
        ...i,
        isSelected: true,
        units: i.course_units?.map((item) => ({ ...item, isSelected: true })) || [],
      }));
      this.selectedItems = this.courses.reduce((acc, cur) => {
        acc.courses.push(cur.id);
        const units = cur.units.map((item) => item.id);
        acc.units = [...acc.units, ...units];
        return acc;
      }, {
        courses: [],
        units: [],
      });
    },
  },
};
</script>
